import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
Portal.propTypes = {
  /** the content to portal */
  children: PropTypes.node,

  /** the element to portal to */
  node: PropTypes.oneOfType([PropTypes.instanceOf(typeof Element !== 'undefined' && Element), PropTypes.any]) // Todo: any = instanceOf(ShadowRoot)

};
Portal.defaultProps = {
  node: typeof document !== 'undefined' && document.body
};
export function Portal(props) {
  var children = props.children,
      node = props.node;
  return /*#__PURE__*/React.createElement(React.Fragment, null, createPortal(children, node));
}
export default Portal;